import React, {useEffect, useState} from "react";
import {useGetTicketByUniqueCode} from "../../hooks/Technician/useGetTicketByUniqueCode";
import {format} from "date-fns";
import {es} from "date-fns/locale/es";
import "./TechnicianTicketInfo.css"
import InstalledEquipmentReview from "../InstalledEquipmentReview/InstalledEquipmentReview";
import CustomerEvaluation from "../CustomerEvaluation/CustomerEvaluation";
import PerformedActions from "../PerformedActions/PerformedActions";

const ticketStateMap: Map<string, string> = new Map([
    ["CREATED", "Creado"],
    ["APPROVED", "Aprobado"],
    ["ASSIGNED", "Asignado"],
    ["IN_PROGRESS", "En progreso"],
    ["BLOCKED", "Bloqueado"],
    ["IN_REVIEW", "En revisión"],
    ["COMPLETED", "Completado"],
]);

const serviceTypeMap: Map<string, string> = new Map([
    ["PREVENTIVE", "Preventivo"],
    ["CORRECTIVE", "Correctivo"],
    ["INSTALLATION", "Instalación"],
    ["VERIFICATION", "Verificación"],
]);

const TechnicianTicketInfo = ({additionalInfo, ticketCode, onBack, showTicketInfo, updateTicketStateLocally}: {
    additionalInfo: any,
    ticketCode: string,
    onBack: () => void,
    showTicketInfo: (show: boolean) => void,
    updateTicketStateLocally: (newState: any) => void
}) => {
    const {ticket, loadingTicket, updatePerformedActionsLocally, updateTicketState} = useGetTicketByUniqueCode(ticketCode);
    const [selectedEquipment, setSelectedEquipment] = useState("");
    const formattedDate = ticket?.createdAt
        ? format(new Date(ticket.createdAt.replace(" ", "T")), "dd MMMM yyyy, HH:mm:ss", {locale: es})
        : "N/A";

    const [showEquipmentReview, setShowEquipmentReview] = useState(false);
    const [showCustomerEvaluation, setShowCustomerEvaluation] = useState(false);
    const [showPerformedActions, setShowPerformedActions] = useState(false);

    const handleStartEquipmentReview = (equipment: any) => {
        setSelectedEquipment(equipment);
        setShowEquipmentReview(true);
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const closeEquipmentReview = () => {
        setShowEquipmentReview(false);
    }

    const [localLoading, setLocalLoading] = useState(true);
    const [initialLoadingMessage, setLoadingMessage] = useState(true);

    useEffect(() => {
        if (!loadingTicket) {
            setTimeout(() => setLocalLoading(false), 600);
        }
    }, [loadingTicket]);

    const handleCompleteTicket = () => {
        setShowCustomerEvaluation(true);
    }

    const handleOpenPerformedActions = () => {
        setShowPerformedActions(true);
    }

    const closeCustomerEvaluation = () => {
        setShowCustomerEvaluation(false);
    }

    const closePerformedActions = () => {
        setShowPerformedActions(false);
    }

    return (
        <div>
            {
                localLoading ? (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">
                                {initialLoadingMessage ? 'Obteniendo ticket...' : 'Guardando datos...'}
                            </div>
                        </div>) :
                    <div className="tickets-info-view-container">
                        {showEquipmentReview ? (
                            <div>
                                <InstalledEquipmentReview
                                    equipment={selectedEquipment}
                                    onBack={closeEquipmentReview}
                                    ticketUniqueCode={ticket.uniqueCode}
                                    ticketState={ticket.ticketState}
                                    setLoadingAnimation={setLocalLoading}
                                    changeLoadingMessage={setLoadingMessage}
                                />
                            </div>
                        ) : showCustomerEvaluation ? <CustomerEvaluation onBack={closeCustomerEvaluation}
                                                                         ticketUniqueCode={ticket.uniqueCode}
                                                                         updateTicketStateLocally={updateTicketStateLocally}
                            updateTicketState={updateTicketState}/> :
                            showPerformedActions ? <PerformedActions onBack={closePerformedActions}
                                                                     ticketPerformedActions={ticket.performedActions}
                                                                     ticketUniqueCode={ticketCode}
                                                                     updatePerformedActionsLocally={updatePerformedActionsLocally}/> : (
                                <div className="tickets-info-view-container">
                                    <div className="tickets-info-view-header">
                                        <button onClick={onBack}>REGRESAR</button>
                                        <div className="tickets-info-view-header-title">
                                            <p>TICKET</p>
                                        </div>
                                        {["ASSIGNED", "IN_PROGRESS"].includes(ticket?.ticketState) && (
                                            <>
        <span className="material-icons-outlined icon-unselected" onClick={handleCompleteTicket}>
            check
        </span>
                                                <span className="material-icons-outlined icon-unselected"
                                                      onClick={handleOpenPerformedActions}>
            format_list_bulleted
        </span>
                                            </>
                                        )}

                                    </div>
                                    <div className="admin-tickets-info-wrapper">
                                        <div className="tickets-info-view-body-info">
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">CLAVE DE TICKET</div>
                                                <div className="value-label">{ticketCode}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">TIPO DE SERVICIO</div>
                                                <div className="value-label">{serviceTypeMap.get(ticket?.service)}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">ESTADO</div>
                                                <div
                                                    className="value-label">{additionalInfo.ESTADO}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">DESCRIPCION</div>
                                                <div className="value-label">{ticket?.description}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">COMENTARIO ADICIONAL</div>
                                                <div className="value-label">{ticket?.additionalComment}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">TÉCNICO ASIGNADO</div>
                                                <div className="value-label">{ticket?.assignedTechnician}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">FECHA DE CREACIÓN</div>
                                                <div className="value-label">{formattedDate}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">CLIENTE</div>
                                                <div className="value-label">{additionalInfo.CLIENTE}</div>
                                            </div>
                                            <div className="ticket-info-attribute">
                                                <div className="attribute-label">PLANTA</div>
                                                <div className="value-label">{additionalInfo.PLANTA}</div>
                                            </div>
                                        </div>
                                        <div className="ticket-additional-info-attribute">
                                            <div className="attribute-label">EQUIPOS</div>
                                            <div className="option-row">
                                                {additionalInfo.EQUIPOS}
                                                {ticket?.equipments?.map((equipment: any, index: any) => (
                                                    <div key={index} className="equipment-row">
                                                        <button
                                                            className={`start-button ${"COMPLETED" === ticket?.ticketState ? 'disabled' : ''}`}

                                                            onClick={() => handleStartEquipmentReview(equipment)}
                                                            disabled={"COMPLETED" === ticket?.ticketState}
                                                        >
                                                            Revisión
                                                        </button>

                                                        <span className="equipment-name">{equipment}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>

            }
        </div>
    );
};

export default TechnicianTicketInfo;
